import * as React from 'react';
const MessageDeliveredIcon = () => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.65007 3.14965C8.45507 2.95465 8.14007 2.95465 7.94507 3.14965L5.12507 5.96965L5.83007 6.67465L8.65007 3.84965C8.84007 3.65965 8.84007 3.33965 8.65007 3.14965ZM10.7701 3.14465L5.83007 8.08465L4.09007 6.34965C3.89507 6.15465 3.58007 6.15465 3.38507 6.34965C3.19007 6.54465 3.19007 6.85965 3.38507 7.05465L5.47507 9.14465C5.67007 9.33965 5.98507 9.33965 6.18007 9.14465L11.4751 3.85465C11.6701 3.65965 11.6701 3.34465 11.4751 3.14965H11.4701C11.2801 2.94965 10.9651 2.94965 10.7701 3.14465ZM0.560068 7.05965L2.65007 9.14965C2.84507 9.34465 3.16007 9.34465 3.35507 9.14965L3.70507 8.79965L1.26507 6.34965C1.07007 6.15465 0.755068 6.15465 0.560068 6.34965C0.365068 6.54465 0.365068 6.86465 0.560068 7.05965Z"
      fill="#969696"
    />
  </svg>
);
export default MessageDeliveredIcon;
